// employee-portal-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'emp.status.received': 'Recibido',
  'emp.change.submitted': 'Enviado',
  'emp.change.resubmitted': 'Reenviado',
  'emp.change.updated': 'Modificado',
  'emp.change.withdrawn': 'Retirado',
  'emp.change.byEmployer': 'el empleador',
  'emp.change.byYou': 'ti',
  'emp.change.text': '{action} por {who}',
  'emp.employerFallback': 'Empleador',
  'emp.employeeFallback': 'Empleado',
  'emp.orgNumber': 'Org. {org}',
  'emp.accountingClient': 'Cliente contable',
  'emp.bg.default': 'Ciruela',
  'emp.bg.mint': 'Menta',
  'emp.bg.varm': 'Cálido',
  'emp.bg.sky': 'Azul',
  'emp.bg.rose': 'Rosa',
  'emp.bg.skog': 'Bosque',
  'emp.portalNotConnected': 'El portal del empleado no está conectado al backend.',
  'emp.portalFetchFailed': 'No se pudo cargar el portal del empleado.',
  'emp.attachReceipt': 'Adjuntar recibo',
  'emp.attachmentFallback': 'Justificante',
  'emp.expenseFillIn': 'Completa la categoría, el importe y la descripción, y adjunta un justificante.',
  'emp.voucherSentToBookkeeping': 'El justificante se ha enviado a contabilización.',
  'emp.expenseSentForApproval': 'Gasto enviado para su aprobación.',
  'emp.expenseSendFailed': 'No se pudo enviar el gasto.',
  'emp.sending': 'Enviando...',
  'emp.sendToBookkeeping': 'Enviar a contabilización',
  'emp.sendForApproval': 'Enviar para aprobación',
  'emp.travelFillIn': 'Completa el motivo, la fecha y el destino.',
  'emp.lineExpenseRequired': 'Se requieren descripción, importe y justificante.',
  'emp.attachmentUploadFailed': 'No se pudo subir el justificante.',
  'emp.mileageFillIn': 'Completa origen, destino y kilómetros.',
  'emp.accommodationFillIn': 'Introduce una descripción del lugar de alojamiento.',
  'emp.editMileage': 'Editar trayecto',
  'emp.newMileage': 'Nuevo trayecto',
  'emp.editAccommodation': 'Editar pernoctación',
  'emp.newAccommodation': 'Nueva pernoctación',
  'emp.editExpense': 'Editar gasto',
  'emp.newExpense': 'Nuevo gasto',
  'emp.saving': 'Guardando...',
  'emp.save': 'Guardar',
  'emp.add': 'Añadir',
  'emp.currency.NOK': 'Coronas noruegas',
  'emp.currency.EUR': 'Euro',
  'emp.currency.USD': 'Dólares estadounidenses',
  'emp.currency.GBP': 'Libras esterlinas',
  'emp.currency.SEK': 'Coronas suecas',
  'emp.currency.DKK': 'Coronas danesas',
  'emp.currency.CHF': 'Francos suizos',
  'emp.currency.ISK': 'Coronas islandesas',
  'emp.currency.PLN': 'Esloti polacos',
  'emp.currency.AUD': 'Dólares australianos',
  'emp.currency.CAD': 'Dólares canadienses',
  'emp.draftSaved': 'Borrador guardado.',
  'emp.draftSaveFailed': 'No se pudo guardar el borrador.',
  'emp.travelResubmitted': 'Viaje reenviado.',
  'emp.travelSentForApproval': 'Viaje enviado para su aprobación.',
  'emp.travelSendFailed': 'No se pudo enviar el viaje.',
  'emp.confirmWithdraw': '¿Retirar el viaje y volver al borrador? El empleador no podrá tramitarlo hasta que lo vuelvas a enviar.',
  'emp.travelWithdrawn': 'El viaje se ha retirado y se puede editar.',
  'emp.withdrawFailed': 'No se pudo retirar el viaje.',
  'emp.confirmDeleteExpenseOfTravel': '¿Eliminar el gasto? Esto también lo quita de la aprobación del empleador.',
  'emp.confirmDeleteTravel': '¿Eliminar el viaje? Esto también lo quita de la aprobación del empleador.',
  'emp.expenseDeleted': 'Gasto eliminado.',
  'emp.travelDeleted': 'Viaje eliminado.',
  'emp.deleteFailed': 'No se pudo eliminar.',
  'emp.editLine': 'Editar línea',
  'emp.withdrawing': 'Retirando...',
  'emp.withdraw': 'Retirar',
  'emp.close': 'Cerrar',
  'emp.saveDraft': 'Guardar borrador',
  'emp.resubmit': 'Reenviar',
  'emp.submitTravel': 'Enviar viaje',
  'emp.fixAndResubmit': 'Corrige el viaje y vuelve a enviarlo.',
  'emp.changedAfterSubmit': 'Modificado tras el envío',
  'emp.changedAfterSubmitText': 'El viaje se modificó después de que lo enviaras. Consulta el historial al final.',
  'emp.addLinesToStart': 'Añade un trayecto, un gasto o una estancia para empezar.',
  'emp.dietCalculated': 'Se calculan las dietas',
  'emp.noDiet': 'Sin dietas (solo gastos/desplazamientos)',
  'emp.noPayrollPayout': 'Este viaje no tiene gastos ni compensaciones que deban pagarse con la nómina.',
  'emp.history': 'Historial',
  'emp.totalCount': '{count} en total',
  'emp.payrollRunFallback': 'Ejecución de nómina',
  'emp.expenseFallback': 'Gasto',
  'emp.voucherFetchFailed': 'No se pudo obtener el justificante.',
  'emp.noPreviewLink': 'No se encontró un enlace de vista previa del justificante.',
  'emp.confirmDeleteExpense': '¿Eliminar el gasto? Esto también lo quita de la aprobación del empleador.',
  'emp.expenseDeleteFailed': 'No se pudo eliminar el gasto.',
  'emp.deleting': 'Eliminando...',
  'emp.delete': 'Eliminar',
  'emp.noAttachmentFound': 'No se encontró ningún justificante',
  'emp.tapToPreview': 'Toca para abrir la vista previa.',
  'emp.noAttachmentName': 'Este gasto no tiene nombre de justificante en el portal del empleado.',
  'emp.previewFetchFailed': 'No se pudo obtener el justificante para la vista previa.',
  'emp.travelFallback': 'Viaje',
  'emp.connectingEmployers': 'Conectando con tus empleadores.',
  'emp.noActiveAccess': 'No tienes ningún acceso activo al portal del empleado con este correo electrónico.',
  'emp.payslipsAvailable': '{count} nóminas disponibles',
  'emp.noPayslipsReady': 'Aún no hay nóminas listas.',
  'emp.pendingApprovedSummary': '{pending} pendientes de aprobación - {approved} aprobados',
});
